import { render } from "./AnimalAddendum.vue?vue&type=template&id=5cb336df&scoped=true"
import script from "./AnimalAddendum.vue?vue&type=script&lang=js"
export * from "./AnimalAddendum.vue?vue&type=script&lang=js"

import "./AnimalAddendum.vue?vue&type=style&index=0&id=5cb336df&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb336df"]])

export default __exports__